import { useTranslation } from 'react-i18next';
import { AccountsFilter, AccountsList, CustomPagination } from '../../../components';

import { AccountFilter } from '../../../models/AccountsFilter';

import './AccountsPage.scss';
import { editAccount, fetchAccounts, GetAllContracts, deleteAccount, updateVerificationCode } from '../../../api/repositoryEP';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AccountData from '../../../models/AccountData';
import { SmallCompanyData } from '../../../models/SmallCompanyData';
import { SmallAgencyData } from '../../../models/SmallAgencyData';
import { NoData } from '../../../components/common';
import { KeyValue } from '../../../models/CommunicationsData';
import { Contract } from '../../../models/Contract';
import ApiResponse from '../../../models/api/ApiResponse';

const AccountsPage = (): JSX.Element => {
    const { t } = useTranslation();
    const defaultPageSize = 10;
    const [searchParams] = useSearchParams();

    const [actualPage, setActualPage] = useState<number>(1);
    const [actualPageSize, setActualPageSize] = useState<number>(defaultPageSize);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [actualFilter, setActualFilter] = useState<AccountFilter>({
        name: searchParams.get('name') ?? '',
        email: '',
        status: '',
        location: '',
        accountType: '',
        page: 0,
        pageSize: defaultPageSize,
    });

    const [companies, setCompanies] = useState<SmallCompanyData[]>([]);
    const [agencies, setAgencies] = useState<SmallAgencyData[]>([]);
    const [contracts, setContracts] = useState<Contract[]>([]);


    const onChangePagination = (newPage: number, newPageSize?: number | undefined) => {
        setActualPage(newPage);
        setActualPageSize(newPageSize ?? defaultPageSize);
        setActualFilter({
            ...actualFilter,
            page: newPage - 1,
            pageSize: newPageSize ?? defaultPageSize
        });
    }

    const [accountList, setAccountList] = useState<AccountData[]>([]);
    const [searching, setSearching] = useState<boolean>(false);
    const onSearch = () => {
        setSearching(true);
        fetchAccounts(actualFilter).then((r) => {
            if (r && r.type === 1) {
                setAccountList(r.data.elements as AccountData[]);
                setTotalRecords(r.data.totalRecords as number);
            } else {
                setAccountList([]);
                setTotalRecords(0);
            }
            setSearching(false);
        })
    }


    useEffect(() => {
        onSearch();
    }, [actualFilter]);

    useEffect(() => {
        GetAllContracts().then((r) => {
            if (r && r.type == 1 && r.data) {
                setContracts(r.data as Contract[]);
            }
        })
    }, []);

    const onEditAccount = async (id: string, isActive: boolean, type: string, contractConfigurationId: string[], paymentConfigurationId: string, useSpecificConfiguration: boolean | null, verificationCode?: string): Promise<ApiResponse | null> => {
        console.log("llega un ", useSpecificConfiguration);
        const response = await editAccount(id, isActive, type, contractConfigurationId, paymentConfigurationId, useSpecificConfiguration ?? null, verificationCode);
        if (response && response.type === 1) {
            setAccountList(prev =>
                prev.map(acc =>
                    acc.id === id
                        ? {
                            ...acc,
                            isActive,
                            status: isActive ? "active" : "inactive",
                            ...(useSpecificConfiguration != null && { useSpecificConfiguration }),
                            ...(verificationCode !== undefined && { verificationCode })
                        }
                        : acc
                )
            );
        }
        return response ?? null;
    };

    const onDeleteAccount = async (id: string, typeAccount: string): Promise<ApiResponse | null> => {
        const response = await deleteAccount(id, typeAccount);
        if (response && response.type === 1) {
            setAccountList(prev => prev.filter(acc => acc.id !== id));
        }
        return response ?? null;
    };

    const onUpdateVerificationCode = async (id: string, typeAccount: string, currentStatus: string, verificationCode: string): Promise<ApiResponse | null> => {
        const response = await updateVerificationCode(id, typeAccount, currentStatus, verificationCode);
        if (response && response.type === 1) {
            setAccountList(prev =>
                prev.map(acc => acc.id === id ? { ...acc, verificationCode } : acc)
            );
        }
        return response ?? null;
    };

    return (
        <div className="accounts-page">
            <div className="filter-container">
                <AccountsFilter onSearch={setActualFilter} actualFilter={actualFilter} searching={searching} />
            </div>
            {
                !searching && accountList.length === 0 ?
                    <NoData />
                    :
                    <div>
                        <div className="list-container">
                            <AccountsList list={accountList} loading={searching}
                                agencies={agencies}
                                companies={companies}
                                contracts={contracts}
                                onEditAccount={onEditAccount}
                                onDeleteAccount={onDeleteAccount}
                                onUpdateVerificationCode={onUpdateVerificationCode}
                            />
                        </div>                        
                        {
                            !searching && <div className="pagination-container">
                                <CustomPagination totalElements={totalRecords} actualPage={actualPage} actualPageSize={actualPageSize} onChange={onChangePagination} />
                            </div>
                        }
                    </div>
            }
        </div>
    )
}

export default AccountsPage;